import React from 'react';
import { Trophy, CheckCircle2, TrendingUp, Target } from 'lucide-react';
import { dashboardData } from './data';
export function CompensationTiers() {
  const {
    compensationTiers
  } = dashboardData;
  return <div data-id="element-47">
      <div className="flex items-center gap-3 mb-6" data-id="element-48">
        <div className="w-9 h-9 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shrink-0" data-id="element-49">
          <TrendingUp size={20} data-id="element-50" />
        </div>
        <h2 className="text-2xl font-black text-[#0a1e5e] uppercase tracking-tight" data-id="element-51">
          How to Grow Your Income
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch" data-id="element-52">
        {compensationTiers.map(tier => {
        const isCurrent = tier.id === 'team_lead';
        const isDivisional = tier.id === 'div_lead';
        let headerBg = 'bg-slate-600';
        if (isCurrent) headerBg = 'bg-[#0a1e5e]';
        if (isDivisional) headerBg = 'bg-orange-600';
        return <div key={tier.id} className={`bg-white rounded-2xl overflow-hidden flex flex-col h-full transition-all duration-300 ${isCurrent ? 'border-2 border-[#0a1e5e] shadow-sm ring-2 ring-blue-100 ring-offset-2 ring-offset-white' : 'border border-slate-200 shadow-sm'}`} data-id="element-53">
              <div className={`${headerBg} text-white p-6 text-center relative`} data-id="element-54">
                {isCurrent && <div className="absolute top-3 right-3 bg-white text-[#0a1e5e] rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider shadow-sm" data-id="element-55">
                    Current
                  </div>}
                <h3 className="text-xl font-black uppercase tracking-wide mb-2" data-id="element-56">
                  {tier.name}
                </h3>
                <p className="text-xs font-medium opacity-90 min-h-[40px] flex items-center justify-center" data-id="element-57">
                  {tier.focus}
                </p>
              </div>

              <div className="p-6 flex-1 flex flex-col" data-id="element-58">
                {tier.baseSalary && <div className="flex items-center justify-between border-b border-slate-200 pb-4 mb-4" data-id="element-59">
                    <span className="text-xs font-bold text-slate-500 uppercase" data-id="element-60">
                      Base Salary
                    </span>
                    <span className="text-lg font-black text-[#0a1e5e]" data-id="element-61">
                      {tier.baseSalary}
                    </span>
                  </div>}

                <div className="mb-6 flex-1" data-id="element-62">
                  <div className="flex items-center gap-2 mb-3" data-id="element-63">
                    <Target size={16} className="text-blue-600" data-id="element-64" />
                    <h4 className="text-xs font-bold text-slate-700 uppercase" data-id="element-65">
                      Compensation Structure
                    </h4>
                  </div>
                  <p className="text-[10px] text-slate-500 mb-3 uppercase font-bold" data-id="element-66">
                    Paid on {isDivisional ? 'Division ' : ''}Closed Units
                  </p>

                  <div className="space-y-2" data-id="element-67">
                    {tier.structure.map((row, idx) => <div key={idx} className="flex justify-between items-center bg-slate-50 rounded-lg p-2.5 min-h-[36px]" data-id="element-68">
                        <span className="text-xs font-bold text-slate-600" data-id="element-69">
                          {row.units}
                        </span>
                        <div className="text-right" data-id="element-70">
                          <span className="text-sm font-black text-[#0a1e5e]" data-id="element-71">
                            {row.bps}
                          </span>
                          {row.extra && <span className="text-[10px] font-bold text-orange-500 ml-1" data-id="element-72">
                              {row.extra}
                            </span>}
                        </div>
                      </div>)}
                  </div>
                </div>

                <div className="bg-slate-50 rounded-xl p-4 mt-auto border border-slate-200" data-id="element-73">
                  <div className="flex items-center gap-2 mb-3" data-id="element-74">
                    <Trophy size={16} className="text-orange-500" data-id="element-75" />
                    <h4 className="text-xs font-bold text-slate-700 uppercase" data-id="element-76">
                      Goals
                    </h4>
                  </div>
                  <ul className="space-y-2" data-id="element-77">
                    {tier.goals.map((goal, idx) => <li key={idx} className="flex items-start gap-2 text-xs text-slate-600 font-medium" data-id="element-78">
                        <CheckCircle2 size={14} className="text-green-500 shrink-0 mt-0.5" data-id="element-79" />
                        <span data-id="element-80">{goal}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>;
      })}
      </div>
    </div>;
}